/** The four built-in task types (spec §9.9), registered like plugins. */
import { registerTaskType } from "../registry/taskTypes";

registerTaskType({
  id: "task",
  label: "types.task",
  icon: "check-square",
  level: "simple",
  propDefs: [],
  completable: true,
  onDone: () => "close",
});

registerTaskType({
  id: "recurring",
  label: "types.recurring",
  icon: "repeat",
  level: "simple",
  propDefs: [],
  completable: true,
  // completing a recurring task resets its clock; it never closes (spec §9.5)
  onDone: () => "keepOpen",
});

registerTaskType({
  id: "note",
  label: "types.note",
  icon: "sticky-note",
  level: "simple",
  propDefs: [],
  completable: false,
});
